import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingCatalogPhasesByLevel1 = (level) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGPHASE}`, `getByLevel/${level}`);
    const body = await resp.json();

     debugLogActions(':: catalogPhaseActions, startLoadingCatalogPhasesByLevel1', { 'body': body });

    if (body.ok) {

      dispatch(loadingCatalogPhasesLevel1(body.catalogPhases));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogPhasesLevel1 = (catalogphases) => ({
  type: types.CATALOGPHASE_START_LOADING_LEVEL1,
  payload: catalogphases,
});

export const startLoadingCatalogPhaseByParent = (idParent, level) => {
  
  return async (dispatch) => {
    
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGPHASE}`,
      `getByParentId/${idParent}`
    );
    const body = await resp.json();

    if (body.ok) {

      if (level === 2) {
        dispatch(loadingCatalogPhasesLevel2ByParent(body.catalogPhases));
      } else if (level === 3) {
        dispatch(loadingCatalogPhasesLevel3ByParent(body.catalogPhases));
      } else if (level === 4) {
        dispatch(loadingCatalogPhasesLevel4ByParent(body.catalogPhases));
      } else if (level === 5) {
        dispatch(loadingCatalogPhasesLevel5ByParent(body.catalogPhases));
      } else if (level === 6) {
        dispatch(loadingCatalogPhasesLevel6ByParent(body.catalogPhases));
      }
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogPhaseByParentLocal = (idParent, level) => {
  
  return async (dispatch, getState) => {
    const state = getState();

    const { listFullCatalogPhases } = state.catalogPhase;

    let catalogPhases = [];
    listFullCatalogPhases.forEach((item) => {
      if (item.parent_id === idParent) {
        catalogPhases.push(item);
      }
    })

    if (level === 2) {
      dispatch(loadingCatalogPhasesLevel2ByParent(catalogPhases));
    } else if (level === 3) {
      dispatch(loadingCatalogPhasesLevel3ByParent(catalogPhases));
    } else if (level === 4) {
      dispatch(loadingCatalogPhasesLevel4ByParent(catalogPhases));
    } else if (level === 5) {
      dispatch(loadingCatalogPhasesLevel5ByParent(catalogPhases));
    } else if (level === 6) {
      dispatch(loadingCatalogPhasesLevel6ByParent(catalogPhases));
    }

  };
};

const loadingCatalogPhasesLevel2ByParent = (catalogphases) => ({
  type: types.CATALOGPHASE_START_LOADING_LEVEL2,
  payload: catalogphases,
});

export const selectCatalogPhaseLevel1 = (catalogphase) => ({
  type: types.CATALOGPHASE_SELECT_LEVEL1,
  payload: catalogphase,
});

const loadingCatalogPhasesLevel3ByParent = (catalogphases) => ({
  type: types.CATALOGPHASE_START_LOADING_LEVEL3,
  payload: catalogphases,
});

export const selectCatalogPhaseLevel2 = (catalogphase) => ({
  type: types.CATALOGPHASE_SELECT_LEVEL2,
  payload: catalogphase,
});

const loadingCatalogPhasesLevel4ByParent = (catalogphases) => ({
  type: types.CATALOGPHASE_START_LOADING_LEVEL4,
  payload: catalogphases,
});

export const selectCatalogPhaseLevel3 = (catalogphase) => ({
  type: types.CATALOGPHASE_SELECT_LEVEL3,
  payload: catalogphase,
});

const loadingCatalogPhasesLevel5ByParent = (catalogphases) => ({
  type: types.CATALOGPHASE_START_LOADING_LEVEL5,
  payload: catalogphases,
});

export const selectCatalogPhaseLevel4 = (catalogphase) => ({
  type: types.CATALOGPHASE_SELECT_LEVEL4,
  payload: catalogphase,
});

const loadingCatalogPhasesLevel6ByParent = (catalogphases) => ({
  type: types.CATALOGPHASE_START_LOADING_LEVEL6,
  payload: catalogphases,
});

export const selectCatalogPhaseLevel5 = (catalogphase) => ({
  type: types.CATALOGPHASE_SELECT_LEVEL5,
  payload: catalogphase,
});

export const selectCatalogPhaseLevel6 = (catalogphase) => ({
  type: types.CATALOGPHASE_SELECT_LEVEL6,
  payload: catalogphase,
});

export const cleanCatalogPhaseLevel1 = () => ({
  type: types.CATALOGPHASE_CLEAN_LEVEL1,
});

export const cleanCatalogPhaseLevel2 = () => ({
  type: types.CATALOGPHASE_CLEAN_LEVEL2,
});

export const cleanCatalogPhaseLevel3 = () => ({
  type: types.CATALOGPHASE_CLEAN_LEVEL3,
});

export const cleanCatalogPhaseLevel4 = () => ({
  type: types.CATALOGPHASE_CLEAN_LEVEL4,
});

export const cleanCatalogPhaseLevel5 = () => ({
  type: types.CATALOGPHASE_CLEAN_LEVEL5,
});

export const cleanCatalogPhaseLevel6 = () => ({
  type: types.CATALOGPHASE_CLEAN_LEVEL6,
});

export const startLoadingCatalogPhaseByCode = (code) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGPHASE}`, `getByLevel/${code}`);
    const body = await resp.json();

    if (body.ok) {
      
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogPhases = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGPHASE}`, "get");
    const body = await resp.json();

    if (body.ok) {
      
      dispatch(loadingCatalogPhases(body.catalogPhases));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogPhases = (catalogPhases) => ({
  type: types.CATALOGPHASE_START_LOADING,
  payload: catalogPhases,
});

export const startLoadingCatalogPhasesPaginatedBk = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGPHASE}`, `get/${page}/${size}`);
    const body = await resp.json();

    debugLogActions(':: catalogPhaseActions, startLoadingCatalogPhasesPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogPhasesPaginated(body.catalogPhasePaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogPhasesPaginated = (page, size, currentCatalogPhase = {}) => {
  return async (dispatch) => {

    let phaseCode = "";
    if (currentCatalogPhase && Object.keys(currentCatalogPhase).length > 0) {
      phaseCode = currentCatalogPhase.code;
    }

    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGPHASE}`, `get/${page}/${size}/${phaseCode}`);
    const body = await resp.json();

    debugLogActions(':: catalogPhaseActions, startLoadingCatalogPhasesPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogPhasesPaginated(body.catalogPhasePaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogPhasesPaginated = (catalogPhasePaginated) => ({
  type: types.CATALOGPHASE_START_LOADING_PAGINATED,
  payload: catalogPhasePaginated,
});

export const selectCatalogPhases = (catalogPhase) => ({
  type: types.CATALOGPHASE_SELECT,
  payload: catalogPhase,
});

export const catalogPhaseClean = () => ({
  type: types.CATALOGPHASE_CLEAN,
});

export const catalogPhaseStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CATALOGPHASE}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {
              if (body.ok) {
                dispatch(catalogPhaseDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogPhaseActions, catalogPhaseStartDelete', { 'error': error });
    }
  };
};

const catalogPhaseDeleted = (id) => {
  return {
    type: types.CATALOGPHASE_DELETE,
    payload: id,
  };
};

export const startSearchingCatalogPhasesPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGPHASE}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(searchingCatalogPhasesPaginated(body.catalogPhasesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingCatalogPhasesPaginated = (catalogPhasesPaginated) => ({
  type: types.CATALOGPHASE_START_SEARCH_PAGINATED,
  payload: catalogPhasesPaginated,
});

export const cleanSearchingCatalogPhasesPaginated = () => ({
  type: types.CATALOGPHASE_CLEAN_SEARCH_PAGINATED,
});

export const catalogPhaseStartUpdate = (catalogPhase, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CATALOGPHASE}`,
        `update/${catalogPhase.id}`,
        catalogPhase,
        "PUT"
      );
      const body = await resp.json();

      if (body.ok) {
        dispatch(catalogPhaseUpdated(catalogPhase));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-phase");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogPhaseActions, catalogPhaseStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} catalogPhase
 * @returns
 */
const catalogPhaseUpdated = (catalogPhase) => {
  return {
    type: types.CATALOGPHASE_UPDATE,
    payload: catalogPhase,
  };
};

export const catalogPhaseStartRegister = (catalogPhase, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGPHASE}`,
      "add",
      catalogPhase,
      "POST"
    );

    const body = await resp.json();

    if (body.ok) {
      dispatch(catalogPhaseRegister(body.catalogPhase));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-phase");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const catalogPhaseRegister = (catalogPhase) => ({
  type: types.CATALOGPHASE_START_REGISTER,
  payload: catalogPhase,
});

export const catalogPhaseSetSearchText = (searchText) => ({
  type: types.CATALOGPHASE_SET_SEARCH_TEXT,
  payload: searchText,
});

export const catalogPhaseCleanSearchText = () => ({
  type: types.CATALOGPHASE_SET_SEARCH_TEXT,
});

export const startLoadingCatalogPhasesAllByLevel6 = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGPHASE}`, `getByLevel/${6}`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingCatalogPhasesLevel6(body.catalogphases_id));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogPhasesLevel6 = (catalogphases) => ({
  type: types.CATALOGPHASE_START_LOADING_ALL_LEVEL6,
  payload: catalogphases,
});

export const startLoadingCatalogPhasesAll = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGPHASE}`, `get`);
    const body = await resp.json();

    debugLogActions(':: catalogPhaseActions, startLoadingCatalogPhasesAll', { 'body': body });

    if (body.ok) {
      dispatch(loadingCatalogPhasesAll(body.catalogPhases));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogPhasesAll = (catalogphases) => ({
  type: types.CATALOGPHASE_START_LOADING_ALL,
  payload: catalogphases,
});

export const startLoadingCatalogPhasesNoLevel6 = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGPHASE}`, `get`);
    const body = await resp.json();

    debugLogActions(':: catalogPhaseActions, startLoadingCatalogPhasesAll', { 'body': body });

    if (body.ok) {

      let filterCatalogPhases = body.catalogPhases.filter(ele => ele.level < 5);

      const phaseWithoutParent = {

        id: 0,
        code: "0000",
        name: "SIN IDENTIFICACIÓN DE ID DE PADRE ",
        level: 0,
        deleted: false,
        code_visual: null,
        createdAt: "2022-10-05T05:20:20.958Z",
        updatedAt: "2022-10-05T05:20:20.958Z",
        parent_id: 9999

      }

      filterCatalogPhases.unshift(phaseWithoutParent);

      dispatch(loadingCatalogPhasesNoLevel6(filterCatalogPhases));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogPhasesNoLevel6 = (catalogphases) => ({
  type: types.CATALOGPHASE_START_LOADING_NO_LEVEL6,
  payload: catalogphases,
});

export const loadingCatalogPhaseFilter = (catalogs) => ({
  type: types.CATALOGPHASE_START_LOADING_FILTER,
  payload: catalogs,
});